var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgMultiPages = function SvgMultiPages(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 16.316",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#63849f",
    d: "M13.112 2.639H5.188A1.893 1.893 0 0 0 3.3 4.528v9.9a1.894 1.894 0 0 0 1.889 1.889h7.924A1.894 1.894 0 0 0 15 14.426v-9.9a1.893 1.893 0 0 0-1.888-1.887m.75 1.889v9.9a.753.753 0 0 1-.751.751H5.188a.75.75 0 0 1-.75-.753v-9.9a.753.753 0 0 1 .751-.751h7.923a.754.754 0 0 1 .75.753"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#63849f",
    d: "M2.548 13.2h-.66a.75.75 0 0 1-.75-.75V1.889a.75.75 0 0 1 .75-.751h7.923a.764.764 0 0 1 .751.8.583.583 0 0 0 .6.537.567.567 0 0 0 .538-.587A1.89 1.89 0 0 0 9.812 0H1.888A1.893 1.893 0 0 0 0 1.889v10.559a1.893 1.893 0 0 0 1.888 1.888H2.6a.57.57 0 0 0 .537-.6.56.56 0 0 0-.589-.536"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMultiPages);
export default ForwardRef;